import type { Document } from "@/api/models"

import {
  formatCitationDisplay,
  formatM365Citation,
  parseCitationParts,
} from "@/utils/citation-utils"
import { normalizeForMatching } from "@/utils/normalize-for-matching"

import { getCitationType } from "./citation.utils"

export function getCitationTitle(
  citation: string,
  documents?: [string, Document][]
): { title: string; pageNumber: number | null } {
  const citationType = getCitationType(citation)
  const cleanCitation = citation.split("#:~:text=")[0]

  if (citationType === "web") {
    try {
      const url = new URL(cleanCitation)
      return { title: url.hostname, pageNumber: null }
    } catch {
      return { title: cleanCitation, pageNumber: null }
    }
  }

  if (citationType === "m365") {
    const { displayName } = formatM365Citation(citation)
    return { title: displayName, pageNumber: null }
  }

  const { fileNameWithoutPage, pageNumber } = formatCitationDisplay(citation, documents)
  const colonIndex = fileNameWithoutPage.indexOf(": ")
  const title =
    colonIndex !== -1 ? fileNameWithoutPage.substring(colonIndex + 2).trim() : fileNameWithoutPage

  if (title) {
    return { title, pageNumber }
  }

  const parsed = parseCitationParts(citation)
  return { title: parsed.source, pageNumber: parsed.page }
}

export function parseCitationIndex(button: HTMLElement): number | null {
  const value = button.dataset.citationIndex
  if (!value) return null
  const parsed = Number.parseInt(value, 10)
  return Number.isNaN(parsed) ? null : parsed
}

export function resolveHighlightSnippets(
  quoteText: string | null,
  chunkText: string | null
): { quoteSnippet: string; chunkSnippet: string } {
  const quoteSnippet = quoteText?.trim() ? normalizeForMatching(quoteText) : ""
  const chunkSnippet =
    chunkText?.trim() && chunkText !== quoteText ? normalizeForMatching(chunkText) : ""
  return { quoteSnippet, chunkSnippet }
}
